import Vue from 'vue'
import Vuex from 'vuex'

import event from './modules/event'
import user from './modules/user'
import shop from './modules/shop'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: { event,user,shop }
})

// document.addEventListener('click', evnt => store.commit('setEvent', evnt))
// window.addEventListener('resize', evnt => store.commit('setEvent', evnt))

export default store



// WEBPACK FOOTER //
// ./src/TASMini/store/index.js